<template>
  <a-form-model :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }" :colon="false" ref="form" :model="form.data" :rules="form.rules">
    <a-tabs>
      <a-tab-pane tab="角色信息" key="ROLE_INFO">
        <a-form-model-item label="角色" prop="name">
          <a-input v-model="form.data.name"/>
        </a-form-model-item>
        <a-form-model-item label="编码" prop="code">
          <a-input v-model="form.data.code"/>
        </a-form-model-item>
        <a-form-model-item label="描述" prop="description">
          <a-input v-model="form.data.description"/>
        </a-form-model-item>
        <a-form-model-item label="是否有效" prop="isActive">
          <a-radio-group v-model="form.data.isActive">
            <a-radio value="YES">有效</a-radio>
            <a-radio value="NO">无效</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-tab-pane>
      <a-tab-pane tab="角色菜单" key="ROLE_MENU">
        <a-tree
          v-model="form.data.menuIds"
          :auto-expand-parent="true"
          checkable
          showLine
          :tree-data="menu.data"
          node-key="id">
        </a-tree>
      </a-tab-pane>
    </a-tabs>
<!--    <a-form-model-item>-->
<!--      <a-space>-->
<!--        <a-button type="primary" v-if="!roleId" @click="onAdd">{{ $t('CREATE') || '创建' }}</a-button>-->
<!--        <a-button type="primary" v-if="roleId" @click="onUpdate">{{ $t('UPDATE') || '创建' }}</a-button>-->
<!--        <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>-->
<!--      </a-space>-->
<!--    </a-form-model-item>-->
  </a-form-model>
</template>

<script>
import {
  _queryRole,
  _addRole,
  _updateRole,
} from '@/api/sys/sysRoleApi';
import {
  _treeGenerator,
  _queryMenus,
} from '@/api/sys/sysMenuApi';


async function getRole() {
  const result = await _queryRole(this.roleId);
  if (result) {
    this.form.data.name = result.data.role.name;
    this.form.data.description = result.data.role.description;
    this.form.data.code = result.data.role.code;
    this.form.data.isActive = result.data.role.isActive;
    this.form.data.menuIds = result.data.menus.map(x => x.menuId);
  }
}

async function onAdd() {
  this.form.disabled = true;
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addRole({
        name: this.form.data.name,
        description: this.form.data.description,
        code: this.form.data.code,
        isActive: this.form.data.isActive,
        menuIds: this.form.data.menuIds,
      });
      if (result) {
        // if (this.onSubmitHandler) {
          this.$message.success(this.$t('ADD_SUCCESS'));
          this.getRoleList();
          // this.onSubmitHandler();
        // }
      }
    } else {
      this.form.disabled = false;
    }
  });
}

async function onUpdate() {
  this.form.disabled = true;
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateRole(this.roleId, {
        name: this.form.data.name,
        description: this.form.data.description,
        isActive: this.form.data.isActive,
        menuIds: this.form.data.menuIds,
        code: this.form.data.code
      });
      if (result) {
        // if (this.onSubmitHandler) {
          this.$message.success(this.$t('UPDATE_SUCCESS'));
          this.getRoleList();
          // if (this.onSubmitHandler) {
          //   this.onSubmitHandler();
          // }
        // }
      }
    } else {
      this.form.disabled = false;
    }
  });
}

function onCancel() {
  // if (this.onCancelHandler) {
  //   this.onCancelHandler();
  // }
}

export default {
  name: 'RoleEdit',
  props: {
    roleId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
    getRoleList: Function
  },
  watch: {
    roleId(val) {
      if (val) {
        this.getRole();
      }
      this.form.data = {
        name: '',
        description: '',
        isActive: 'YES',
        menuIds: [],
        code: ''
      };
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getRole,
    save(){
      if(!this.roleId){
        this.onAdd()
      } else {
        this.onUpdate()
      }
    }
  },
  data() {
    return {
      tab: 'ROLE_INFO',
      menu: {
        data: [],
      },
      form: {
        data: {
          name: '',
          description: '',
          isActive: 'YES',
          menuIds: [],
          code: ''
        },
        rules: {
          name: [{
            required: true,
            message: '请输入姓名',
            trigger: 'blur',
          }],
          code: [{
            required: true,
            message: '请输入编码',
            trigger: 'blur',
          }],
          description: [{
            required: false,
            message: 'please input description',
            trigger: 'blur',
          }],
          isActive: [{
            required: false,
            message: 'please choose isActive',
            trigger: 'blur',
          }],
        },
        disabled: false,
        title: '',
      },
    };
  },
  async created() {
    this.tab = 'roleInfo';
    const menuResult = await _queryMenus();
    this.menu.data = menuResult
      .filter(x => !x.parentId)
      .map(x => _treeGenerator(x, menuResult));
    if (this.roleId) {
      this.getRole();
    }
  },
};
</script>














<!--<template>-->
<!--  <a-form-model ref="form" :model="form.data" :rules="form.rules">-->
<!--    <a-tabs v-model="tab">-->
<!--      <a-tab-pane label="角色信息" name="roleInfo">-->
<!--        <a-form-model-item label="角色" prop="name">-->
<!--          <a-input v-model="form.data.name"/>-->
<!--        </a-form-model-item>-->
<!--        <a-form-model-item label="编码" prop="code">-->
<!--          <a-input v-model="form.data.code" :disabled="roleId?true:false"/>-->
<!--        </a-form-model-item>-->
<!--        <a-form-model-item label="描述" prop="description">-->
<!--          <a-input v-model="form.data.description"/>-->
<!--        </a-form-model-item>-->
<!--        <a-form-model-item label="是否有效" prop="isActive">-->
<!--          <a-radio v-model="form.data.isActive" label="YES">有效</a-radio>-->
<!--          <a-radio v-model="form.data.isActive" label="NO">无效</a-radio>-->
<!--        </a-form-model-item>-->
<!--      </a-tab-pane>-->
<!--      <a-tab-pane label="角色菜单" name="roleMenu">-->
<!--        <a-tree-->
<!--          ref="menuTree"-->
<!--          default-expand-all-->
<!--          check-strictly-->
<!--          :default-checked-keys="form.data.menuIds"-->
<!--          :props="{children: 'children',label: 'name'}"-->
<!--          :data="menu.data"-->
<!--          show-checkbox-->
<!--          node-key="id">-->
<!--          <div class="custom-tree-node" slot-scope="{ node, data }">-->
<!--            <i class="fa fa-list " v-if="data.type==='MENU'"/>-->
<!--            <i class="fa fa-hand-pointer-o" v-if="data.type==='BUTTON'"/>-->
<!--            {{ node.label }}-->
<!--          </div>-->
<!--        </a-tree>-->
<!--      </a-tab-pane>-->
<!--    </a-tabs>-->
<!--    <a-form-model-item>-->
<!--      <a-button type="primary" v-if="!roleId" @click="onAdd">创建</a-button>-->
<!--      <a-button type="primary" v-if="roleId"  @click="onUpdate">更新</a-button>-->
<!--      <a-button @click="onCancel">取消</a-button>-->
<!--    </a-form-model-item>-->
<!--  </a-form-model>-->
<!--</template>-->

<!--<script>-->
<!--import {-->
<!--  _queryRole,-->
<!--  _addRole,-->
<!--  _updateRole,-->
<!--} from '@/api/sysRoleApi';-->
<!--import {-->
<!--  _treeGenerator,-->
<!--  _queryMenus,-->
<!--} from '@/api/sysMenuApi';-->


<!--async function getRole() {-->
<!--  const result = await _queryRole(this.roleId);-->
<!--  if (result.code === 1200) {-->
<!--    this.form.data.name = result.data.role.name;-->
<!--    this.form.data.description = result.data.role.description;-->
<!--    this.form.data.isActive = result.data.role.isActive;-->
<!--    this.form.data.code = result.data.role.code;-->
<!--    this.form.data.menuIds = result.data.menus.map(x => x.menuId);-->
<!--  }-->
<!--}-->

<!--async function onAdd() {-->
<!--  this.form.disabled = true;-->
<!--  this.$refs.form.validate(async (valid) => {-->
<!--    if (valid) {-->
<!--      const nodes = this.$refs.menuTree.getCheckedNodes();-->
<!--      const result = await _addRole({-->
<!--        name: this.form.data.name,-->
<!--        description: this.form.data.description,-->
<!--        isActive: this.form.data.isActive,-->
<!--        code: this.form.data.code,-->
<!--        menuIds: nodes.map(x => x.id),-->
<!--      });-->
<!--      if (result.code === 1200) {-->
<!--        if (this.onSubmitHandler) {-->
<!--          this.$message({-->
<!--            message: '添加成功',-->
<!--            type: 'success',-->
<!--          });-->
<!--          this.onSubmitHandler();-->
<!--        }-->
<!--      }-->
<!--    } else {-->
<!--      this.form.disabled = false;-->
<!--    }-->
<!--  });-->
<!--}-->

<!--async function onUpdate() {-->
<!--  this.form.disabled = true;-->
<!--  this.$refs.form.validate(async (valid) => {-->
<!--    if (valid) {-->
<!--      const nodes = this.$refs.menuTree.getCheckedNodes();-->
<!--      const result = await _updateRole(this.roleId, {-->
<!--        name: this.form.data.name,-->
<!--        description: this.form.data.description,-->
<!--        isActive: this.form.data.isActive,-->
<!--        code: this.form.data.code,-->
<!--        menuIds: nodes.map(x => x.id),-->
<!--      });-->
<!--      if (result.code === 1200) {-->
<!--        if (this.onSubmitHandler) {-->
<!--          this.$message({-->
<!--            message: '更新成功',-->
<!--            type: 'success',-->
<!--          });-->
<!--          if (this.onSubmitHandler) {-->
<!--            this.onSubmitHandler();-->
<!--          }-->
<!--        }-->
<!--      }-->
<!--    } else {-->
<!--      this.form.disabled = false;-->
<!--    }-->
<!--  });-->
<!--}-->

<!--function onCancel() {-->
<!--  if (this.onCancelHandler) {-->
<!--    this.onCancelHandler();-->
<!--  }-->
<!--}-->

<!--export default {-->
<!--  name: 'RoleEdit',-->
<!--  props: {-->
<!--    roleId: String,-->
<!--    onSubmitHandler: Function,-->
<!--    onCancelHandler: Function,-->
<!--  },-->
<!--  watch: {-->
<!--    roleId(val) {-->
<!--      if (val) {-->
<!--        this.getRole();-->
<!--      }-->
<!--      this.form.data = {-->
<!--        name: '',-->
<!--        description: '',-->
<!--        isActive: 'YES',-->
<!--        menuIds: [],-->
<!--      };-->
<!--    },-->
<!--  },-->
<!--  methods: {-->
<!--    onAdd,-->
<!--    onUpdate,-->
<!--    onCancel,-->
<!--    getRole,-->
<!--  },-->
<!--  data() {-->
<!--    return {-->
<!--      tab: 'roleInfo',-->
<!--      menu: {-->
<!--        data: [],-->
<!--      },-->
<!--      form: {-->
<!--        data: {-->
<!--          name: '',-->
<!--          description: '',-->
<!--          isActive: 'YES',-->
<!--          menuIds: [],-->
<!--        },-->
<!--        rules: {-->
<!--          name: [{-->
<!--            required: true,-->
<!--            message: '请输入姓名',-->
<!--            trigger: 'blur',-->
<!--          }],-->
<!--          description: [{-->
<!--            required: false,-->
<!--            message: 'please input description',-->
<!--            trigger: 'blur',-->
<!--          }],-->
<!--          isActive: [{-->
<!--            required: false,-->
<!--            message: 'please choose isActive',-->
<!--            trigger: 'blur',-->
<!--          }],-->
<!--        },-->
<!--        disabled: false,-->
<!--        title: '',-->
<!--      },-->
<!--    };-->
<!--  },-->
<!--  async created() {-->
<!--    this.tab = 'roleInfo';-->
<!--    const menuResult = await _queryMenus();-->
<!--    this.menu.data = menuResult.data.menus-->
<!--      .filter(x => !x.parentId)-->
<!--      .map(x => _treeGenerator(x, menuResult.data.menus));-->

<!--    if (this.roleId) {-->
<!--      this.getRole();-->
<!--    }-->
<!--  },-->
<!--};-->
<!--</script>-->
